import React from "react";
import { Box, BoxProps, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "calc(100% - 344px)",
    padding: "40px 0 56px 48px",
    [theme.breakpoints.down('md')]: {
      width: "unset",
      padding: theme.spacing(3.25, 1, 5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3.25, 0, 5),
    },
  },
}));

const RightContent = ({
  children,
  className,
  ...otherProps
}: React.HTMLAttributes<HTMLElement> & BoxProps) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      flex="1"
      bgcolor="background.default"
      className={`${classes.container} ${className || ""}`}
      {...(otherProps || {})}
    >
      {children}
    </Box>
  );
};

export default RightContent;
